'use strict';

import {breakpoints} from "../settings/breakpoints";

const ImageFixer = (($) => {

    const NAME = 'imageFixer';
    const JQUERY_NO_CONFLICT = $.fn[NAME];

    const Default = {}

    class ImageFixer {
        $element = false;
        static get Default() {
            return Default
        }

        constructor($element, config) {
            this._config = $.extend({}, Default, config);
            this.$element = $element;

            this.init();
            this.addEventListeners();

            var _ = this;
        }

        init() {
            // console.log(breakpoints);

            var self = this;

            this.isMobile = window.matchMedia('(max-width: 767px)').matches;

            // console.log(window.matchMedia('(max-width: 767px)').matches);

                // this.elements = this.$element.find('.js-fixer-equalize');

            this.equalizeHeightRow();
            // this.equalizeSpecial();
        }

        addEventListeners() {
            var _self = this;

            $(window).on('load resize', function(e) {
                // console.log('load, resize');
                _self.isMobile = window.matchMedia('(max-width: 767px)').matches;
                _self.equalizeHeightRow();
                _self.equalizeSpecial();
            });
        }

        equalizeHeightRow() {
            if (this.isMobile) {
                this.$element.find('.js-fixer-equalize img').parent().height('auto');
                return;
            }

            this.$element.find('.js-fixer-equalize').each(function() {
                var $container = $(this);

                var images = $container.find('img');

                var minHeight = 100000;

                images.each(function () {
                    var height = $(this).height();

                    if (height < minHeight) {
                        minHeight = height;
                    }
                    // console.log(height);
                });

                images.each(function () {
                    images.parent().height(minHeight);
                });
            });
        }


        equalizeSpecial() {
            if (this.isMobile) {
                this.$element.find('.js-fixer-special').each(function() {
                    var thirdImage = $(this).find('.ce_image').eq(2);
                    thirdImage.find('.effect-container').height('auto');
                    thirdImage.find('img').height('auto').width('100%');
                });
                return;
            }

            this.$element.find('.js-fixer-special').each(function() {
                var $container = $(this);

                var firstImage = $container.find('.ce_image').eq(0);
                var secondImage = $container.find('.ce_image').eq(1);
                var thirdImage = $container.find('.ce_image').eq(2);

                // console.log($(firstImage).outerHeight(true));
                // console.log($(secondImage).find('.effect-container').height());

                var referenceHeight = $(firstImage).outerHeight(true) + $(secondImage).find('.effect-container').height();

                // console.log(referenceHeight);

                thirdImage.find('.effect-container').height(referenceHeight);
                thirdImage.find('img').height('100%').width('auto');

            });
        }


        static _jQueryInterface(config) {
            config = config || {};
            return this.each(() => {
                let $this = $(this);
                let _config = $.extend(
                    {},
                    ImageFixer.Default,
                    $this.data(),
                    typeof config === 'object' && config
                );

                new ImageFixer(this, _config)
            })
        }
    }

    $.fn[NAME] = ImageFixer._jQueryInterface;
    $.fn[NAME].Constructor = ImageFixer;
    $.fn[NAME].noConflict = () => {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return ImageFixer._jQueryInterface
    };

    return ImageFixer;

})(jQuery);

export default ImageFixer;